import PolicyTypeBadge from "components/PolicyTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

const PoliciesTableTypeCell = ({ item: policy, ...cellProps }: TableSimpleCellProps<Policy>) => (
  <TableSimpleCell {...cellProps}>
    <PolicyTypeBadge type={policy.type} />
  </TableSimpleCell>
);

export default PoliciesTableTypeCell;
